import { render, staticRenderFns } from "./tag-group-edit-modal.vue?vue&type=template&id=b1b45c10&scoped=true&"
import script from "./tag-group-edit-modal.vue?vue&type=script&lang=js&"
export * from "./tag-group-edit-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b45c10",
  null
  
)

export default component.exports